
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 108 108"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ffbf52","d":"M49.091.22l38.952 18.73 9.62 42.084-26.955 33.75H27.475L.519 61.033l9.62-42.085z"}}),_c('path',{attrs:{"fill":"#ffa306","d":"M29.547 14.268l35.767-.178 22.44 27.803-7.785 34.849L47.82 92.393l-32.303-15.33-8.133-34.77z"}}),_c('g',[_c('path',{attrs:{"fill":"#fff","d":"M60.65 49.628h-4.21v-4.295h4.212zm-13.398 0v-4.295h4.223v4.295zm-4.929 0h-4.235v-4.295h4.235zM62.578 32h-27.29L30 37.242v19.806l5.288 5.653V72l8.335-9.573 19.336.274L68 57.32V37.517z"}})])])
          )
        }
      }
    